<template>
  <div>
    <members-caption>
      連絡先
    </members-caption>

    <contact-info />

    <members-caption>
      メンバー状況
    </members-caption>
    <total />
    <list />
  </div>
</template>

<script>
import MembersCaption from './Caption'
import ContactInfo from './ContactInfo'
import Total from './Total'
import List from './List/index'

export default {
  components: {
    MembersCaption,
    ContactInfo,
    Total,
    List
  }
}
</script>
